export default {
  data () {
    return {

    }
  },
  methods: {
    //跳转项目包主页
    toProjectHomePage(id) {
      this.$router.push({
        path: "/pojecthomepage",
        query: {
          id: id
        }
      })
    },
  },
  props: {
    courses: Array,
    name: String
  }
}